export default __webpack_public_path__ + "static/media/extract-light.0424aea2.png";